// extracted by mini-css-extract-plugin
export var Community = "index-module--Community--4L6P1";
export var descAppear = "index-module--descAppear--+MbZP";
export var descToOpacity = "index-module--descToOpacity--YrII-";
export var swiperStyle = "index-module--swiperStyle--LndGo";